let DataService = {};
DataService.Languages = [{
  id: 'vi',
  name: 'Tiếng Việt'
}, {
  id: 'en',
  name: 'Tiếng Anh'
}];

DataService.gioiTinh = [
  {
    id: 1,
    text: "Nữ"
  },
  {
    id: 2,
    text: "Nam"
  },
  {
    id: 3,
    text: "Chưa có thông tin"
  },
  {
    id: 4,
    text: "Khác"
  },
];

DataService.doiTuongHienThi = [
  {
    code: 'Doctor_His',
    text: 'Bác sỹ'
  },
  {
    code: 'Doctor_Hos',
    text: 'Bác sỹ trạm'
  },
  {
    code: 'Hospital',
    text: 'Bệnh viện'
  },
  {
    code: 'Citizen',
    text: 'Người dân'
  },
  {
    code: 'All',
    text: 'Tất cả'
  }
]

DataService.timeOutRequest = null;
DataService.DoDaiSoThe = 16;

export default DataService;
